import { Stack, Box } from "@mui/material";
import React from "react";
import Text from "../../../components/Text";
import mut from "../../../hooks/mut";
import AddButton from "../../../components/AddButton";
export default function LocationDetails(props) {

  let { location, setCenter, center } = props;



  return (
    <Box
      padding={1}
      border={1}
      borderRadius={5}
      marginLeft={2}
      borderColor={"#CCCCCC"}
    >
      <Stack spacing={2}>
        <Text
          label="Name"
          value={location.name}
          setValue={name => {
            let nc = { ...center }
            let l = nc.locations.find(l => l._id === location._id);
            l.name = name;
            setCenter(nc);
          }}
          url={`/center/location-name/${location._id}`}
          field="name"
        />
        <div style={{ fontSize: 13 }}>Rooms</div>
        {location.rooms.map((r) => (
          <div>
            <Text
              value={r.name}
              key={r._id}
              setValue={name => {
            let nc = { ...center }
            let l = nc.locations.find(l => l._id === location._id);
            let room = l.rooms.find(room => room._id === r._id);
            room.name = name; 
            setCenter(nc);
              
              }}
              url={`/center/location-room/${location._id}/${r._id}`}
              field="name"
             
            />
          
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "center" }}>
       
          <AddButton action={async () => {
            let rooms = await mut("post", `/center/location/${location._id}/rooms/add`, { name: "new room" });
            let nc = { ...center }
            let l = nc.locations.find(l => l._id === location._id);
            l.rooms = rooms
            setCenter(nc);
          }}/>
        </div>
      </Stack>
    </Box>
  );
}

/*  const [locations, setLocations] = React.useState(props.locations);

  const [render, setRender] = React.useState(0);

  React.useEffect(() => {
    setLocations(props.locations);
  }, [props.locations]);

  const updateRoom = (e, i) => {
    console.log(e.target.name);
    let newlocations = locations;

    newlocations[props.location].rooms.find(
      (r) => r._id === e.target.name
    ).name = e.target.value;
    setLocations(newlocations);
    setRender(render + 1);
  };

  const addRoom = (e, i) => {
    props.net
      .post(`/center/location/${locations[props.location].name}/rooms/add`, {
        name: "new room from app",
      })
      .then((result) => {
        console.log(result);

        setLocations(result);
        setRender(render + 1);
      });
  };

  const updateRoomServer = (e) => {
    props.net.post(
      `/center/location/${locations[props.location].name}/rooms/${
        e.target.name
      }/update`,
      { name: e.target.value }
    );
  };

  if (location.length < 1) return <div>No Locations</div>;
  return (
    <Box border={1} padding={2} borderRadius={5} ml={2} borderColor={"#CCCCCC"}>
      <Stack spacing={2}>
        <TextField
          label="Name"
          placeholder="Name"
          variant="standard"
          value={locations[props.location].name}
        ></TextField>
        <div>
          Rooms:
          <div>
            {locations[props.location].rooms.map((room, index) => (
              <div key={room + index}>
                <TextField
                  name={room._id}
                  variant="standard"
                  value={room.name}
                  onChange={updateRoom}
                  onBlur={updateRoomServer}
                ></TextField>
              </div>
            ))}
          </div>
          <div
            style={{
              padding: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button variant="contained" onClick={addRoom} mt={5}>
              Add room
            </Button>
          </div>
        </div>
      </Stack>
    </Box>
  ); */
